var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMixedActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3232_25491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6608 18.7028C53.1903 15.5362 49.3383 13.5 45.0108 13.5C41.2829 13.5 37.9079 15.011 35.4649 17.4541C34.1333 18.7856 33.0785 20.3941 32.3945 22.1857C31.9732 23.2891 32.8653 24.3752 34.0464 24.3752H34.1945C35.0361 24.3752 35.7575 23.8055 36.1 23.0368C36.5897 21.9374 37.2769 20.9453 38.1165 20.1057C39.8809 18.3413 42.3185 17.25 45.0108 17.25C48.3006 17.25 51.2099 18.8793 52.9757 21.375H49.6608C48.6254 21.375 47.7858 22.2145 47.7858 23.25C47.7858 24.2856 48.6254 25.125 49.6608 25.125H57.5358C58.0331 25.125 58.5101 24.9275 58.8617 24.5759C59.2133 24.2243 59.4108 23.7473 59.4108 23.25V15.375C59.4108 14.3395 58.5714 13.5 57.5358 13.5C56.5004 13.5 55.6608 14.3395 55.6608 15.375V18.7028Z",
    fill: "#A046D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3232_25491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3608 35.2974V38.625C34.3608 39.6606 33.5214 40.5 32.4858 40.5C31.4503 40.5 30.6108 39.6606 30.6108 38.625V30.75C30.6108 30.2528 30.8084 29.7758 31.16 29.4242C31.5116 29.0726 31.9886 28.875 32.4858 28.875H40.3608C41.3964 28.875 42.2358 29.7144 42.2358 30.75C42.2358 31.7856 41.3964 32.625 40.3608 32.625H37.0459C38.8117 35.1207 41.7209 36.7501 45.0108 36.7501C47.7031 36.7501 50.1406 35.6588 51.9051 33.8943C52.7446 33.0548 53.4319 32.0627 53.9215 30.9633C54.264 30.1946 54.9855 29.625 55.827 29.625H55.9752C57.1563 29.625 58.0483 30.711 57.6271 31.8144C56.943 33.606 55.8882 35.2145 54.5566 36.546C52.1136 38.9891 48.7386 40.5001 45.0108 40.5001C40.6833 40.5001 36.8314 38.4639 34.3608 35.2974Z",
    fill: "#A046D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3232_25491",
    x: 18.2885,
    y: 3.5,
    width: 55.1223,
    height: 39.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25491"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3232_25491",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3232_25491",
    x: 16.6108,
    y: 18.875,
    width: 55.1223,
    height: 39.6252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25491"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3232_25491",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixedActive);
export default __webpack_public_path__ + "static/media/mixed-active.5d2ad563dfeb681c17b8520490f38950.svg";
export { ForwardRef as ReactComponent };